
import React from 'react';
import AdminLayout from "@/components/admin/AdminLayout";
import RootFileUploader from "@/components/admin/tools/file-uploader/RootFileUploader";
import { useAdminCheck } from "@/hooks/useAdminCheck";

const RootFileManager = () => {
  const { isLoading, isAdmin } = useAdminCheck();

  // For SSR initial render - show minimal loading state
  if (typeof window === 'undefined') {
    return <div>Loading...</div>;
  }

  // Show loading until auth check completes
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <p className="text-lg">Loading dashboard...</p>
      </div>
    );
  }

  // If not admin after auth check, should have been redirected by useAdminCheck
  if (!isAdmin) {
    return null;
  }

  return (
    <AdminLayout 
      title="Root File Manager"
      backLink="/admin/dashboard"
      backLabel="Back to Dashboard"
    >
      <div className="max-w-5xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">Domain Root File Manager</h1>
        <p className="text-gray-600 mb-8">
          Upload files that will be accessible directly at your domain root (e.g., yourdomain.com/filename.ext).
          These files are stored on Cloudflare and served directly from your domain.
        </p>
        
        <RootFileUploader />
      </div>
    </AdminLayout>
  );
};

export default RootFileManager;
